// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input.Common:not(.is-valid):not(.is-invalid) {
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.45rem;
}`, "",{"version":3,"sources":["webpack://./src/common/Input/styles.scss"],"names":[],"mappings":"AACE;EACE,wCAAA;EACA,4BAAA;EACA,wBAAA;AAAJ","sourcesContent":[".Input.Common {\n  &:not(.is-valid):not(.is-invalid) {\n    background-position: right 0.5rem center;\n    background-repeat: no-repeat;\n    background-size: 1.45rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
